module.exports = __webpack_public_path__ + "static/media/dots.f8ea5dda.svg";